import {call, put} from "redux-saga/effects";
import {creationNouveauPackageApi} from "../../../../common/apis/packageApi";
import * as actions from "../state/nouveauPackageActions";

export function* creationNouveauPackageSaga({ payload }) {
  try {
    const response = yield call(creationNouveauPackageApi, payload);
    yield put(actions.creationNouveauPackageSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.creationNouveauPackageFailAction(error));
  }
}
